import { put, call } from 'redux-saga/effects';
import axios from 'axios';
import { alertDialogSetSaga } from '../alertDialog';

import { getSessionToken } from '../../../constants/session';

import * as actions from '../../actions/index';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const putUserGroupSettings = process.env.REACT_APP_ACCOUNT_UPDATE_UG_SETTINGS;

export function* putUserGroupSettingsSaga(action) {
    const url = baseUrl + putUserGroupSettings;

    try {
        yield put(actions.putUgAccountSettingsStart());
        const sessionToken = getSessionToken();

        const body = action.data;

        const response = yield axios.put(url, JSON.stringify(body), {
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionToken,
            },
        });
        yield call(alertDialogSetSaga, {
            data: {
                open: true,
                severityLevel: 'success',
                message: 'User Group Settings successfully submitted',
            },
        });
        yield put(actions.putUgAccountSettingsSuccess(response.data.result));
        yield put(actions.signout());
    } catch (error) {
        yield call(alertDialogSetSaga, {
            data: {
                open: true,
                severityLevel: 'error',
                message:
                    'Edit User Group Settings unsuccessful, please try again',
            },
        });
        yield put(actions.putUgAccountSettingsFail(error));
    }
}
